$(() => {
  const key = 'decline-negotiation-action';
  $(`[data-${key}]`).on('click', function() {
    $('form.decline').attr('action', $(this).data(key));
  });
});
